var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb-container"},[_c('ul',{staticClass:"uk-breadcrumb"},_vm._l((this.$route.meta.breadcrumbs),function(crumb,crumbIndex){return _c('li',{key:crumbIndex},[_c('a',{class:{ disabled: _vm.isLast(crumbIndex) },attrs:{"href":crumb.url}},[_vm._v(_vm._s(crumb.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }